import { WorkOrderState } from '../types';
import { daysRange } from 'app/constants/dates';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const workOrderState: WorkOrderState = {
  workOrderList: [],
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  totalRecordCount: 0,
  sortBy: '-id',
  sortField: 'workOrderId',
  fromRequestDate: daysRange.minDay.startOf('day').toUTC().toISO(),
  toRequestDate: daysRange.maxDay.endOf('day').toUTC().toISO(),
  recordId: '',
  status: 'open',
  userId: null,
  toDelete: [],
  deleting: false,
  creating: false,
  docType: 'pdf',
  isExportToggleOn: false,
  fieldArray: [],
  summaryReportDateRange: {
    fromDate: daysRange.minDay.toISODate(),
    toDate: daysRange.maxDay.toISODate(),
  },
  summaryReportToggle: false,
  columns: [
    {
      id: 'selection',
      field: 'selection',
      order: 0,
      isVisible: true,
      option: { width: '30px' },
    },
    {
      id: 'workOrderId',
      field: 'workOrderId',
      header: 'Work Order ID',
      order: 1,
      isVisible: true,
      option: { width: '130px', sortBy: 'id' },
    },
    {
      id: 'resource',
      field: 'resource',
      header: 'Resources',
      order: 2,
      isVisible: true,
      option: { width: '130px' },
    },
    {
      id: 'jobsite',
      field: 'jobsite',
      header: 'Jobsite',
      order: 3,
      isVisible: true,
      option: { width: '150px' },
    },
    {
      id: 'requestedStartTime',
      field: 'requestedStartTime',
      header: 'Resquested Start Time',
      order: 4,
      isVisible: true,
      option: { width: '160px', sortBy: 'requested_start_time' },
    },
    {
      id: 'timeCompleted',
      field: 'timeCompleted',
      header: 'Time Completed',
      order: 5,
      isVisible: true,
      option: { width: '150px', sortBy: 'completed_time' },
    },
    {
      id: 'totalTimeWorked',
      field: 'totalTimeWorked',
      header: 'Total Time Worked',
      order: 6,
      isVisible: true,
      option: { width: '150px' },
    },
    {
      id: 'status',
      field: 'status',
      header: 'Status',
      order: 7,
      isVisible: true,
      option: { width: '80px' },
    },
    {
      id: 'action',
      field: 'action',
      header: 'Action',
      order: 8,
      isVisible: true,
      option: { width: '80px' },
    },
  ],
};
